import styled from 'styled-components';
import React from 'react';
import { SectionParent, BlueButton } from '../../StyledComponents';
import Image from 'gatsby-image';
import { navigate, StaticQuery, graphql } from 'gatsby';
import { SectionOneTitle } from '../HomePage/HomepageSectionOne';

const Section = styled(SectionParent)`
  display: grid;
  padding-top: 5rem !important;
  position: relative;
  z-index: 0;
  padding-bottom: 0rem !important;
  display: grid;
  border-bottom: 55px solid #5cbd9a;
  background: #f4f6fb;
`;

const SectionTwo = styled(SectionParent)`
  display: grid;
  padding-top: 4rem !important;
  position: relative;
  z-index: 0;
  display: grid;
  min-height: 300px;
  background-image: linear-gradient(181deg, #eff3f9, #dbe4f6);
`;

const SolutionsContent = styled.div`
  grid-column: span 7;
  display: grid;
  /* padding-bottom: 4rem; */
  @media (max-width: 768px) {
    grid-column: span 14;
    padding-bottom: 2rem;
    padding-left: 0;
  }
  @media (max-width: 520px) {
    grid-column: span 14;
    padding-left: 0;
  }
`;
const BlueButtonWrapper = styled.div`
  /* margin-top: -6rem; */
  justify-content: center;
  display: grid;
  margin-top: 2rem;
  margin-bottom: 2rem;
  @media (max-width: 768px) {
    justify-self: center;
    margin-top: 0;
  }
`;

const SolutionsImageContainerImg = styled(Image)`
  animation: fadein 1s;
  height: 8rem;
  max-width: 124px;
  margin: auto;
  img {
    object-fit: contain !important;
  }
  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const SolutionsContainer = styled(SectionParent)`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  justify-content: center;
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const FromManufacturingT = styled.h2`
  font-size: 18px;
  line-height: 31px;
  margin: auto;
  text-align: center;
  justify-self: center;
  width: 500px;
  max-width: 80%;
  @media (max-width: 1700px) {
    font-size: 18px;
  }
  @media (max-width: 1440px) {
    font-size: 18px;
  }
  @media (max-width: 1024px) {
    font-size: 18px;
  }
  @media (max-width: 768px) {
    font-size: 16px;
    width: 80%;
    margin-left: 10%;
    text-align: center;
  }
  margin-top: 1rem;
  margin-bottom: 0rem;
  color: #737680;
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 400;
  @media (max-width: 480px) {
    /* margin-bottom: -50%; */
  }
`;

const EsperManagePage = styled.div`
  padding-top: 4rem;
  @media (max-width: 768px) {
    padding-top: 1rem;
  }
`;

const HeroImgMobileContainer = styled(Image)`
  display: none;
  position: static !important;
  @media (max-width: 520px) {
    display: unset;
    width: 100%;
  }
`;

const HeroImgContainerLeft = styled(Image)`
  top: 8rem;
  width: 100%;
  margin-bottom: -4.8%;
  position: static !important;

  @media (max-width: 520px) {
    display: none;
  }
`;
const HeroImgContainer = styled.div`
  /* height: 19.7rem; */
  position: relative;
`;

const SolutionContainerItemText = styled.div`
  /* text-align: center; */
  margin-top: 5px;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #26315c;
  text-align: center;
`;

const SolutionContainerItem = styled.div`
  position: relative;
  @media (max-width: 520px) {
    justify-self: center;
    width: 100%;
  }
`;
class ManageSectionOne extends React.PureComponent<any, any> {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            manageDesktop: file(
              relativePath: { eq: "v2/manage/group-41@3x.png" }
            ) {
              childImageSharp {
                fluid(quality: 85, jpegProgressive: true) {
                  aspectRatio
                  src
                  srcSet
                  sizes
                  srcWebp
                  srcSetWebp
                }
              }
            }
            manageMobile: file(
              relativePath: { eq: "v2/manage/manage-mobile.png" }
            ) {
              childImageSharp {
                fluid(quality: 85, jpegProgressive: true) {
                  aspectRatio
                  src
                  srcSet
                  sizes
                  srcWebp
                  srcSetWebp
                }
              }
            }

            kioskImage: file(relativePath: { eq: "v2/png/kiosk.png" }) {
              childImageSharp {
                fluid(maxHeight: 120, jpegProgressive: true) {
                  aspectRatio
                  src
                  srcSet
                  sizes
                  srcWebp
                  srcSetWebp
                }
              }
            }

            ruggedImage: file(relativePath: { eq: "v2/png/rugged.png" }) {
              childImageSharp {
                fluid(maxHeight: 120, jpegProgressive: true) {
                  aspectRatio
                  src
                  srcSet
                  sizes
                  srcWebp
                  srcSetWebp
                }
              }
            }

            posImage: file(relativePath: { eq: "v2/png/pos.png" }) {
              childImageSharp {
                fluid(maxHeight: 120, jpegProgressive: true) {
                  aspectRatio
                  src
                  srcSet
                  sizes
                  srcWebp
                  srcSetWebp
                }
              }
            }

            tabImage: file(relativePath: { eq: "v2/png/tab.png" }) {
              childImageSharp {
                fluid(maxHeight: 120, jpegProgressive: true) {
                  aspectRatio
                  src
                  srcSet
                  sizes
                  srcWebp
                  srcSetWebp
                }
              }
            }
          }
        `}
        render={(data: any) => (
          <div style={{ position: 'relative' }}>
            <Section>
              <SolutionsContent>
                <EsperManagePage>
                  <SectionOneTitle
                    style={{
                      textAlign: 'center',
                    }}
                  >
                    Deploy - Manage - Monitor
                  </SectionOneTitle>
                  <FromManufacturingT>
                    Manage your Android device fleet effortlessly through
                    Esper's intuitive cloud based platform.
                  </FromManufacturingT>
                  <HeroImgContainer>
                    <HeroImgContainerLeft
                      alt="Esper Manage"
                      loading="lazy"
                      fluid={data.manageDesktop.childImageSharp.fluid}
                    />
                    <HeroImgMobileContainer
                      alt="Esper Manage"
                      loading="lazy"
                      fluid={data.manageMobile.childImageSharp.fluid}
                    />
                  </HeroImgContainer>
                </EsperManagePage>
              </SolutionsContent>
            </Section>
            <SectionTwo>
              <SolutionsContainer>
                <SolutionContainerItem>
                  <SolutionsImageContainerImg
                    alt="Esper Kiosk"
                    loading="lazy"
                    fluid={data.kioskImage.childImageSharp.fluid}
                  />
                  <SolutionContainerItemText>Kiosks</SolutionContainerItemText>
                </SolutionContainerItem>
                <SolutionContainerItem>
                  <SolutionsImageContainerImg
                    alt="Esper Rugged"
                    loading="lazy"
                    fluid={data.ruggedImage.childImageSharp.fluid}
                  />
                  <SolutionContainerItemText>Rugged</SolutionContainerItemText>
                </SolutionContainerItem>
                <SolutionContainerItem>
                  <SolutionsImageContainerImg
                    alt="Esper POS"
                    loading="lazy"
                    fluid={data.posImage.childImageSharp.fluid}
                  />
                  <SolutionContainerItemText>POS</SolutionContainerItemText>
                </SolutionContainerItem>
                <SolutionContainerItem>
                  <SolutionsImageContainerImg
                    alt="Esper Tab"
                    loading="lazy"
                    fluid={data.tabImage.childImageSharp.fluid}
                  />
                  <SolutionContainerItemText>{`Mobile & Tablet`}</SolutionContainerItemText>
                </SolutionContainerItem>
              </SolutionsContainer>

              <BlueButtonWrapper>
                <BlueButton
                  onClick={() => navigate('/signup')}
                  id="manage__start_free_trial"
                  style={{ marginLeft: '0', backgroundColor: '#725cbd' }}
                >
                  Start trial
                </BlueButton>
              </BlueButtonWrapper>
            </SectionTwo>
          </div>
        )}
      />
    );
  }
}
export default ManageSectionOne;
